<template>
  <div ref="bar" class="chips-bar" :class="{ 'chips-bar--wrap': wrap }" role="group">
    <button
      v-for="chip in chips"
      :key="chip.value"
      class="chip"
      :class="{ 'chip--active': modelValue === chip.value }"
      @click="$emit('update:modelValue', chip.value)"
    >
      {{ chip.label }}
      <span v-if="chip.count !== undefined && chip.count !== null" class="chip__count">
        {{ chip.count }}
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ChipsBar',
  // Vue 2: declarar el mapping de v-model para usar modelValue + update:modelValue
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    chips: {
      type: Array,
      required: true
    },
    modelValue: {
      type: [String, Number, Boolean],
      default: null
    },
    // Para juegos largos que los pone el dato (una pastilla por propiedad): en
    // pantalla ancha envuelven en vez de desbordar.
    wrap: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  watch: {
    modelValue () { this.$nextTick(this.scrollActiveIntoView) }
  },
  mounted () {
    this.scrollActiveIntoView()
  },
  methods: {
    // Cuando la barra se desliza (juego largo en pantalla angosta) la pastilla
    // activa puede quedar fuera de cuadro, y entonces no hay NADA en pantalla
    // que diga qué se está mirando: llegar por ?estateId= a la propiedad número
    // trece dejaba la tira empezada en «Todas» y una sola fila sin explicación.
    // Se mueve sólo el carril horizontal — tocar el scroll vertical de la
    // página al cambiar de filtro sería peor que no hacer nada.
    scrollActiveIntoView () {
      const bar = this.$refs.bar
      if (!bar || bar.scrollWidth <= bar.clientWidth) return
      const index = this.chips.findIndex(c => c.value === this.modelValue)
      const el = index >= 0 ? bar.children[index] : null
      if (!el) return
      const barBox = bar.getBoundingClientRect()
      const elBox = el.getBoundingClientRect()
      // Centrar en el carril; el navegador recorta solo en los extremos
      bar.scrollLeft += (elBox.left - barBox.left) - (bar.clientWidth - elBox.width) / 2
    }
  }
}
</script>
